import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const KEY = "gg_cookie_consent";

export default function CookieBanner() {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    const timer = setTimeout(() => setShow(true), 2800);
    return () => clearTimeout(timer);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          className="fixed bottom-5 left-5 right-5 sm:right-auto sm:max-w-md z-[120] bg-surface2 border border-line p-6 shadow-2xl"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="flex items-center gap-3 mb-3">
            <Cookie size={18} strokeWidth={1.5} className="text-brass" />
            <p className="eyebrow text-[10px]">{t.cookies.title}</p>
          </div>
          <p className="text-stone text-sm font-light leading-relaxed">{t.cookies.text}</p>
          <div className="mt-5 flex gap-3">
            <button
              data-testid="cookie-accept"
              onClick={() => decide("accepted")}
              className="bg-brass text-ink text-[12px] uppercase tracking-[0.14em] font-semibold rounded-full px-6 py-2.5 hover:bg-cream transition-colors duration-400"
            >
              {t.cookies.accept}
            </button>
            <button
              data-testid="cookie-reject"
              onClick={() => decide("rejected")}
              className="border border-line text-cream/80 text-[12px] uppercase tracking-[0.14em] rounded-full px-6 py-2.5 hover:border-brass hover:text-brass transition-colors duration-400"
            >
              {t.cookies.reject}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
